/**
 * Canonical timezone option list for all UI timezone selects.
 *
 * Values are short codes (CST, EST, CDT, ...) for human-readable display
 * and to match the legacy `co_timezone` column shape on customer_config /
 * contact_profiles. Where multiple aliases collide (BST appears for both
 * Bangladesh and British Summer Time) the second is suffixed.
 *
 * NOT IANA names. If a downstream consumer needs to do DST math, map
 * these codes to IANA via `TZ_TO_IANA` below.
 */
export const TIMEZONES = [
    { value: 'GMT', label: 'Greenwich Mean Time (GMT)' },
    { value: 'UTC', label: 'Coordinated Universal Time (UTC)' },
    { value: 'ECT', label: 'European Central Time (ECT)' },
    { value: 'EET', label: 'Eastern European Time (EET)' },
    { value: 'ART', label: 'Arabic Standard Time (ART)' },
    { value: 'EAT', label: 'Eastern African Time (EAT)' },
    { value: 'MET', label: 'Middle East Time (MET)' },
    { value: 'NET', label: 'Near East Time (NET)' },
    { value: 'PLT', label: 'Pakistan Lahore Time (PLT)' },
    { value: 'IST', label: 'India Standard Time (IST)' },
    { value: 'BST', label: 'Bangladesh Standard Time (BST)' },
    { value: 'VST', label: 'Vietnam Standard Time (VST)' },
    { value: 'CTT', label: 'China Taiwan Time (CTT)' },
    { value: 'JST', label: 'Japan Standard Time (JST)' },
    { value: 'ACT', label: 'Australia Central Time (ACT)' },
    { value: 'AET', label: 'Australia Eastern Time (AET)' },
    { value: 'SST', label: 'Solomon Standard Time (SST)' },
    { value: 'NST', label: 'New Zealand Standard Time (NST)' },
    { value: 'MIT', label: 'Midway Islands Time (MIT)' },
    { value: 'HST', label: 'Hawaii Standard Time (HST)' },
    { value: 'AST', label: 'Alaska Standard Time (AST)' },
    { value: 'PST', label: 'Pacific Standard Time (PST)' },
    { value: 'PNT', label: 'Phoenix Standard Time (PNT)' },
    { value: 'MST', label: 'Mountain Standard Time (MST)' },
    { value: 'CST', label: 'Central Standard Time (CST)' },
    { value: 'EST', label: 'Eastern Standard Time (EST)' },
    { value: 'IET', label: 'Indiana Eastern Standard Time (IET)' },
    { value: 'PRT', label: 'Puerto Rico & US Virgin Islands Time (PRT)' },
    { value: 'CNT', label: 'Canada Newfoundland Time (CNT)' },
    { value: 'AGT', label: 'Argentina Standard Time (AGT)' },
    { value: 'BET', label: 'Brazil Eastern Time (BET)' },
    { value: 'CAT', label: 'Central African Time (CAT)' },
    { value: 'CDT', label: 'Central Daylight Saving Time — US/Canada/Mexico (CST)' },
    { value: 'EDT', label: 'Eastern Daylight Saving Time — US/Canada/Mexico (EST)' },
    { value: 'MDT', label: 'Mountain Daylight Saving Time — US/Canada (MST)' },
    { value: 'PDT', label: 'Pacific Daylight Saving Time — US/Canada (PST)' },
    { value: 'ADT', label: 'Atlantic Daylight Saving Time — Canada (AST)' },
    { value: 'NDT', label: 'Newfoundland Daylight Saving Time — Canada (NST)' },
    { value: 'BSTu', label: 'British Summer Time (BST)' },
    { value: 'CEST', label: 'Central European Summer Time (CEST)' },
    { value: 'EEST', label: 'Eastern European Summer Time (EEST)' },
];
/** Quick value→label lookup for read-only renders. */
export const TIMEZONE_LABEL = Object.fromEntries(TIMEZONES.map((t) => [t.value, t.label]));
//# sourceMappingURL=timezones.js.map